// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { ContextualInviteNudgeFlagBaseProps } from './ContextualInviteNudgeFlag.tsx';

export type { ContextualInviteNudgeFlagBaseProps } from './ContextualInviteNudgeFlag.tsx';
// eslint-disable-next-line check-react-ssr-usage/no-static-and-loadable-export
export { LIVE_PAGE_SOURCE } from './ContextualInviteNudgeFlag.tsx';

export const ContextualInviteNudgeFlagLoadable: LoadableType<
	Omit<ContextualInviteNudgeFlagBaseProps, 'flags'>
> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ContextualInviteNudgeFlag" */ './ContextualInviteNudgeFlag.tsx'
			)
		).ContextualInviteNudgeFlag,
});
